module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.14913/js/img/white_sprocket.svg"